import { render, staticRenderFns } from "./SpousePersonalData.vue?vue&type=template&id=76896a3e&"
import script from "./SpousePersonalData.vue?vue&type=script&lang=js&"
export * from "./SpousePersonalData.vue?vue&type=script&lang=js&"
import style0 from "./SpousePersonalData.vue?vue&type=style&index=0&id=76896a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports